export default "__VITE_ASSET__2d3e8a68__"